import IArResult from '../checkout/IArResult';
import CartHandler from './Handlers/CartHandler';

export default class GTM {
    static init(url: string[]) {
        GTM.buttonSignInHandler();
        GTM.signInHandler();
        GTM.catalogHandler(url);
        GTM.productHandler(url);
        const containerUser = document.getElementById('gtm-user-container');
        const isAuth = GTM.getContent(containerUser, 'userIsAuth');
        let cartHandler = {};
        if (isAuth === 'true') {
            cartHandler = new CartHandler(
                true,
                GTM.getContent(containerUser, 'userEmail')
            );
        } else {
            cartHandler = new CartHandler(false);
        }
    }

    static buttonSignInHandler() {
        document.addEventListener('click', (event) => {
            const target = event.target as HTMLElement;

            const parentTarget = target.parentElement as
                | HTMLDivElement
                | HTMLButtonElement;

            const isButtonsContainer =
                parentTarget.classList.contains('buttons');
            let isButtonContainer = false;

            if ('name' in parentTarget) {
                isButtonContainer = parentTarget.name === 'Login1';
            }

            if (isButtonsContainer || isButtonContainer) {
                global.window.dataLayer.push({
                    event: 'user_signin_submit',
                    eventProps: {
                        action: 'user_signin_submit',
                        category: 'account',
                        label: 'standard',
                        value: 1,
                    },
                });
            }
        });
    }

    static signInHandler() {
        const topCtrl = document.querySelector('.top-ctrl');
        let loginedElement;
        let isLogin = false;
        if (topCtrl !== null) {
            isLogin = topCtrl.querySelector('.logined') !== null;
            loginedElement = topCtrl.querySelector('.logined');
        }

        const localStorageIsLogin = window.localStorage.getItem('isLogin');
        let visitorName = null;
        let visitorEmail = null;

        if (loginedElement) {
            visitorName = topCtrl
                .querySelector('.logined')
                .getAttribute('title');
            visitorEmail = (topCtrl.querySelector('.logined') as HTMLElement)
                .dataset.email;
        }
        if (isLogin && localStorageIsLogin !== 'false') {
            window.localStorage.setItem('isLogin', String(isLogin));
        }
        if (window.localStorage.getItem('isLogin') === 'true') {
            window.localStorage.setItem('isLogin', String(false));
            global.window.dataLayer.push({
                event: 'user_signin_success',
                eventProps: {
                    action: 'user_signin_success',
                    category: 'account',
                    label: 'standard',
                    value: 1,
                },
            });
        }
        if (isLogin) {
            global.window.dataLayer.push({
                VisitorEmail: visitorEmail,
                VisitorName: visitorName,
            });
        }
    }

    static catalogHandler(url: string[]) {
        const firstChunk = 1;
        const notParamQ = GTM.findGetParameter('q') === null;
        const isCatalog = url[firstChunk] === 'catalog' && notParamQ;

        if (isCatalog) {
            const containerUser = document.getElementById('gtm-user-container');
            const isAuth = GTM.getContent(containerUser, 'userIsAuth');
            const lastChunkId = 2;
            const lastChunk = url[url.length - lastChunkId];
            const containerSection = document.getElementById(
                'gtm-section-container'
            );

            const data = {
                event: 'flListView',
                eventProps: {
                    catID: lastChunk,
                    dataMindbox: {
                        data: {
                            viewProductCategory: {
                                productCategory: {
                                    ids: {
                                        website: GTM.getContent(
                                            containerSection,
                                            'sectionId'
                                        ),
                                    },
                                },
                            },
                        },
                        operation: 'Website.ViewCategory',
                    },
                },
                sectionId: GTM.getContent(containerSection, 'sectionId'),
            };

            if (isAuth === 'true') {
                const email = GTM.getContent(containerUser, 'userEmail');

                data.eventProps.username = GTM.getContent(
                    containerUser,
                    'userName'
                );
                data.eventProps.email = email;
                data.eventProps.dataMindbox.data.customer = { email };
            }
            global.window.dataLayer.push(data);

            // GA4 ecommerce
            let items = document.getElementById('gtm-section-container-items');
            let resultItems = [];
            for (let item of items.querySelectorAll(
                '.gtm-section-container-item'
            )) {
                resultItems.push([
                    {
                        item_name: GTM.getContent(item, 'name'),
                        item_id: GTM.getContent(item, 'article'),
                        price: GTM.getContent(item, 'price'),
                        item_brand: GTM.getContent(item, 'brand'),
                        item_category: GTM.getContent(item, 'item_category_0'),
                        item_variant: GTM.getContent(item, 'variant'),
                        item_list_name: GTM.getContent(item, 'item_list_name'),
                        item_list_id: GTM.getContent(item, 'item_list_id'),
                    },
                ]);
            }
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
                event: 'view_item_list',
                ecommerce: {
                    items: resultItems,
                },
            });
        }
    }

    static purchaseHandler(arResult: IArResult, orders: string[]) {
        arResult.BASKET.GROUPS.forEach(
            (group: { PRODUCTS: (string | number)[] }, i: number) => {
                const arEvent = {
                    event: 'purchase',
                    ecommerce: {
                        transaction_id: String(orders[i]),
                        affiliation: '',
                        value: 0,
                        tax: 0,
                        shipping: group.DELIVERY_PRICE ?? 0,
                        currency: 'RUB',
                        coupon: '',
                        items: {},
                    },
                };
                // @ts-ignore
                const items = [];
                let groupPrice = 0;
                let itemVariant = '';
                let coupon = '';
                let shipping = 0;

                if (group.DELIVERY_PRICE) {
                    shipping = group.DELIVERY_PRICE;
                }
                // Проверяем наличие купона
                if (arResult.TOTAL.COUPONS) {
                    coupon = arResult.TOTAL.COUPONS[0].COUPON;
                }

                // Ищем выбранный вкус для оффера
                group.PRODUCTS.forEach((product: string | number) => {
                    if (arResult.BASKET.ITEMS[product].OFFERS) {
                        arResult.BASKET.ITEMS[product].OFFERS.forEach(
                            (offer: { PRODUCT_ID: any; FLAVOR: string }) => {
                                if (
                                    offer.PRODUCT_ID ==
                                    arResult.BASKET.ITEMS[product].PRODUCT_ID
                                ) {
                                    itemVariant = offer.FLAVOR;
                                }
                            }
                        );
                    }

                    groupPrice += Number(
                        arResult.BASKET.ITEMS[product].PRICE ??
                            arResult.BASKET.ITEMS[product].PRICE_WITH_DISCOUNT
                    );
                    items.push({
                        item_name: arResult.BASKET.ITEMS[product].NAME,
                        item_id: arResult.BASKET.ITEMS[product].ARTICLE,
                        price: Number(
                            arResult.BASKET.ITEMS[product].PRICE ??
                                arResult.BASKET.ITEMS[product]
                                    .PRICE_WITH_DISCOUNT
                        ),
                        discount:
                            Number(
                                arResult.BASKET.ITEMS[product].DISCOUNT_PRICE
                            ) ?? 0,
                        item_brand: arResult.BASKET.ITEMS[product].BRAND_NAME,
                        item_category:
                            arResult.BASKET.ITEMS[product].SECTION_CHAINS[0],
                        item_category2:
                            arResult.BASKET.ITEMS[product].SECTION_CHAINS[1] ??
                            '',
                        item_category3:
                            arResult.BASKET.ITEMS[product].SECTION_CHAINS[2] ??
                            '',
                        item_category4:
                            arResult.BASKET.ITEMS[product].SECTION_CHAINS[3] ??
                            '',
                        item_category5:
                            arResult.BASKET.ITEMS[product].SECTION_CHAINS[4] ??
                            '',
                        item_variant: itemVariant,
                        quantity: Number(
                            arResult.BASKET.ITEMS[product].QUANTITY
                        ),
                    });
                });

                // @ts-ignore
                arEvent.ecommerce.items = items;
                arEvent.ecommerce.value = Number(groupPrice);
                arEvent.ecommerce.coupon = coupon;
                arEvent.ecommerce.shipping = Number(shipping);
                global.window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                global.window.dataLayer.push(arEvent);
                window.localStorage.setItem(
                    `GA_purchase_${String(orders[i])}`,
                    'true'
                );
            }
        );
    }

    static productHandler(url: string[]) {
        const firstChunk = 1;
        const isProduct = url[firstChunk] === 'product';

        if (isProduct) {
            const containerUser = document.getElementById('gtm-user-container');
            const containerProduct = document.getElementById(
                'gtm-product-container'
            );
            const isAuth = GTM.getContent(containerUser, 'userIsAuth');
            const avail = GTM.getContent(containerProduct, 'available');
            const category = GTM.getContent(containerProduct, 'section');
            const vendorName = GTM.getContent(containerProduct, 'brand');
            const article = GTM.getContent(containerProduct, 'article');
            const price = GTM.getContent(containerProduct, 'price');

            const data = {
                event: 'flGoodsView',
                eventProps: {
                    available: avail === 'true',
                    catID: category,
                    dataMindbox: {
                        data: {
                            viewProduct: {
                                product: {
                                    ids: {
                                        website: article,
                                    },
                                },
                            },
                        },
                        operation: 'Website.ViewProduct',
                    },
                    vendorName,
                    zItemID: article,
                },
            };

            if (isAuth === 'true') {
                const email = GTM.getContent(containerUser, 'userEmail');

                data.eventProps.username = GTM.getContent(
                    containerUser,
                    'userName'
                );
                data.eventProps.email = email;
                data.eventProps.dataMindbox.data.customer = { email };
            }
            global.window.dataLayer.push(data);

            // GA4 ecommerce
            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
                event: 'view_item',
                ecommerce: {
                    items: [
                        {
                            item_name: GTM.getContent(containerProduct, 'name'), // Name or ID is required.
                            item_id: article,
                            price: Number(price),
                            item_brand: vendorName,
                            item_category: GTM.getContent(
                                containerProduct,
                                'item_category_0'
                            ),
                            item_category2: GTM.getContent(
                                containerProduct,
                                'item_category_1'
                            ),
                            item_category3: GTM.getContent(
                                containerProduct,
                                'item_category_2'
                            ),
                            item_category4: GTM.getContent(
                                containerProduct,
                                'item_category_3'
                            ),
                            item_category5: GTM.getContent(
                                containerProduct,
                                'item_category_4'
                            ),
                            item_variant: GTM.getContent(
                                containerProduct,
                                'variant'
                            ),
                            quantity: 1,
                        },
                    ],
                },
                vendoreCode: article,
            });
        }
    }

    private static getContent(container: HTMLElement, param: string): string {
        return container
            .querySelector(`meta[name="${param}"]`)
            .getAttribute('content');
    }

    private static findGetParameter(parameterName) {
        var result = null,
            tmp = [];
        location.search
            .substr(1)
            .split('&')
            .forEach(function (item) {
                tmp = item.split('=');
                if (tmp[0] === parameterName)
                    result = decodeURIComponent(tmp[1]);
            });
        return result;
    }
}
